@use '../dialog/style';
